import React, {useEffect, useState, useRef} from 'react';
import Axios from 'axios';
import { Alert } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import '../App.css';
import Pagination from '../components/global/Paginator'
import {exportToExcel} from "../utils/reports/exportToExcel";
import {formatDate} from "../utils/dates";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExcel} from "@fortawesome/free-solid-svg-icons";
import userImage from "../media/account-user-group-people-person-profile-svgrepo-com.svg"

function Grillaboticketusersreport (props){
    const fileInputRef = useRef();
    const searchInput = useRef(null);
    const [show, setShow] = useState(false);
    const [datos, setDatos] = useState([]);
    const [datosDetalle, setDatosDetalle] = useState([]);
    const [datosBackup, setDatosBackup] = useState([])
    const [datosExport, setDatosExport] = useState([]);
    const [idcasino, setIdCasino] = useState()

    const [direccioncasino, setDireccionCasino] = useState()
    const [valorticketcasino, setValorTicketCasino] = useState()
    const [fecha, setFecha] = useState('')
    const [visible, setVisible] = useState('seccionNoVisible')
    const [beneficiariobyuser, setBeneficiariobyuser] = useState([])
    const [beneficiario, setBeneficiario] = useState()
    const [ticketid, setTicketId] = useState()
    const [user, setUser] = useState()
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);


    const [fechaInicio, setFechaInicio] = useState('')
    const [usuario, setUsuario] = useState('')
    const [fechafinal, setFechaFinal] = useState('')
    const [file, setFile] = useState('');
    const [fileName, setFileName] = useState("");
    const [barcoderest, setBarcoderest] = useState('')
    const [pageNumber, setPageNumber] = useState('')
    const [pageSize, setPageSize] = useState(3);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);   
    const [typeUser, setTypeUser] = useState('Apoderado')

    // Referencia para el número de página (evitar estados desincronizados)
    const pageRef = useRef(currentPage);
 

    let statuscall = '' 
    
    const dataList = datos.map((item, i) =>
        <tr key={i} class="divide-y divide-gray-100 bg-white">
            <td class="px-6 py-4 whitespace-nowrap text-sm">{item.id}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">{item.password}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">{item.rut}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">{item.nombre}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">{item.apellido}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">{item.tipo_usuario}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">{item.cuenta_apoderado}</td>
            <td class="px-6 py-4 whitespace-nowrap text-right text-sm">
                <button class="text-indigo-600 hover:underline text-sm" onClick={() => verDetalleUsuario(item.id, item.tipo_usuario)}>Detalle Usuario</button>
            </td>
        </tr> 

    );


    const handleExport = () => {
    
        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLTICKETUSERSREPORTEXCEL, {
            params: {
                casino: idcasino.replace('"', ''),
                tipousuario: typeUser || ''               
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatosExport(response.data.usuarios)
        }).catch(error => {
            return error     
        });

        const formattedData = datosExport.map((usuarios) => ({
            ID: usuarios.id,
            Password: usuarios.password,
            Rut: usuarios.rut,
            Nombre: usuarios.nombre,
            Apellido: usuarios.apellido,
            Tipo_usuario: usuarios.tipo_usuario,
            Cuenta: usuarios.cuenta_apoderado
        }))
        if(typeUser == 'Apoderado'){
            exportToExcel(formattedData, `ReporteUsuarios_${formatDate()}.xlsx`, "Apoderados");
        }else{
            exportToExcel(formattedData, `ReporteUsuarios_${formatDate()}.xlsx`, "Alumnos");
        }
    };


    const dataListDetalle = datosDetalle.map((item, i) => (
        
        <div key={i} className="w-full">
            {item.tipo_usuario === 'apoderado' ? (
            <div className="w-full bg-white rounded-lg shadow-lg p-12">
                
                <div className="flex justify-center mb-4">
                <img 
                    src={userImage} 
                    alt="Imagen de Usuario" 
                    className="h-24 w-24 rounded-full border-2 border-gray-300 object-cover"
                />
                </div>

                <div className="text-center mb-6">
                <h2 className="text-xl font-semibold text-gray-800">{item.nombre}</h2>
                <p className="text-sm text-gray-500">Perfil: <span className="text-blue-600">{item.perfil}</span></p>
                </div>

                <div className="space-y-4">
                <div className="flex justify-between">
                    <span className="font-medium text-gray-600">ID:</span>
                    <span className="text-gray-700">{item.id}</span>
                </div>
                <div className="flex justify-between">
                    <span className="font-medium text-gray-600">RUT:</span>
                    <span className="text-gray-700">{item.rut}</span>
                </div>
                <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Teléfono:</span>
                    <span className="text-gray-700">{item.telefono}</span>
                </div>
                <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Estado:</span>
                    <span className="text-gray-700">{item.estado}</span>
                </div>
                <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Casino:</span>
                    <span className="text-gray-700">{item.casino}</span>
                </div>
                </div>
            </div>
            ):(
                <div className="w-full bg-white rounded-lg shadow-lg p-12">
                
                <div className="flex justify-center mb-4">
                <img 
                    src={userImage} 
                    alt="Imagen de Usuario" 
                    className="h-24 w-24 rounded-full border-2 border-gray-300 object-cover"
                />
                </div>

                <div className="text-center mb-6">
                <h2 className="text-xl font-semibold text-gray-800">{item.nombre} {item.apellido}</h2>
                <p className="text-sm text-gray-500">Apoderado: <span className="text-blue-600">{item.apoderado}</span></p>
                </div>

                <div className="space-y-4">
                <div className="flex justify-between">
                    <span className="font-medium text-gray-600">ID:</span>
                    <span className="text-gray-700">{item.id}</span>
                </div>
                <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Estado:</span>
                    <span className="text-gray-700">{item.estado}</span>
                </div>
                <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Casino:</span>
                    <span className="text-gray-700">{item.casino}</span>
                </div>
                </div>
            </div>        
             )}
        </div>

    ));
      

    const handlePageSize = (e) => {
        setPageSize(e.target.value)
    }

    const GetTicket = () =>
    {

        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLTICKETUSERSREPORT, {
            params: {
                page: pageNumber || 1,
                pageSize: pageSize || 10,
                casino: idcasino.replace('"', ''),
                tipousuario: typeUser || ''
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            
            setDatos(response.data.usuarios)
            setDatosBackup(response.data.usuarios)

            setCurrentPage(response.data.usuarios_metadata.currentPage)
            setPageNumber(response.data.usuarios_metadata.currentPage)

            setTotalPages(response.data.usuarios_metadata.totalPages)
        }).catch(error => {
            return error     
        });
    }

    useEffect(() => {
        GetTicket()

    }, [pageNumber]);



    const verDetalleUsuario= (user_id, tipo_usuario) =>{
        //Busca beneficiarios por usuario
        console.log(user_id + ' ' + tipo_usuario)
        Axios.get(process.env.REACT_APP_URLTICKETUSERSREPORTDETALLE, {
            params: {
                tipo_usuario: tipo_usuario,
                user_id: user_id
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatosDetalle(response.data.detalle_usuarios)

        }).catch(error => {
            return error     
        });

        handleShow()
    }

    const handleClose = () => {
        setBeneficiario('')
        setFecha('')
        setShow(false)
    }
    const handleShow = () => setShow(true)

    const handleChangeList= (e) => {
        let text = e.target.value;
        const setBusqueda = e.target.value;
        const data = datosBackup
        const newData = data.filter(
            function(item){
                const itemDataUsuario = item.id
                const campo = itemDataUsuario
                const textData = text
                return campo.indexOf(textData) > -1        
            }
        )
        setDatos(newData)
    }


    const handleTypeUser = (e) => {
        setTypeUser(e.target.value)
    }



    return(
    <div className='w-full'>
        {/* Zona 1 - Filtros */}
        <div className="bg-white shadow-lg p-6 mx-4 mb-2">


        {/* Zona 1 - Header con Título y Filtros */}
        <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
        <h1 class="text-2xl font-bold">Reporte Usuarios</h1>

        <div class="flex flex-wrap gap-4">

                <div className="flex flex-col">
                    <label className="flex items-center space-x-2">
                        <input
                        type="radio"
                        name="role"
                        value="Apoderado"
                        onChange={handleTypeUser}
                        className="form-radio h-4 w-4 text-blue-600"
                        />
                        <span>Apoderado</span>
                    </label>

                    <label className="flex items-center space-x-2">
                        <input
                        type="radio"
                        name="role"
                        value="Alumno"
                        onChange={handleTypeUser}
                        className="form-radio h-4 w-4 text-blue-600"
                        />
                        <span>Alumno</span>
                    </label>
                </div>

                {/* Campo Selección Número de Páginas */}
                <div className="flex flex-col">
                    <input 
                    type="number" 
                    id="numeroPaginas"
                    placeholder='Registros por pagina'
                    value={pageSize}
                    onChange={handlePageSize} 
                    min="1" 
                    step="1" 
                    defaultValue="1" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                </div>

                {/*Buscador*/}
                <div class="relative">
                <input type="text" 
                    placeholder="Buscar en grilla" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    id="Buscar en grilla"
                    onChange={handleChangeList}  />
                <div class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35m1.4-5.4a7 7 0 11-14 0 7 7 0 0114 0z"/>
                    </svg>
                </div>
                </div>

                {/* Botón generar reporte */}
                <button
                    onClick={GetTicket}
                    className="flex items-center gap-2 bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium px-4 py-2 rounded-lg shadow"
                    >
                    <svg
                        className="w-4 h-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 4H7a2 2 0 01-2-2V6a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2z"
                        />
                    </svg>
                    <span>Generar Reporte</span>
                </button>

                {/*Botón Exportar a Excel*/}
                <button onClick={handleExport} class="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium px-4 py-2 rounded-lg shadow">
                <svg class="w-4 h-4 fill-current text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M384 121.9V128H272V0H128C92.7 0 64 28.7 64 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160h64v-38.1c0-13.1-10.6-23.9-23.7-23.9H384zM299.1 272l-42.1 48 42.1 48H258l-26.5-31.1L205 368h-40.5l42.1-48-42.1-48H205l26.5 31.1L258 272h41.1z"/>
                </svg>
                <span>Export</span>
                <svg class="w-4 h-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4" />
                </svg>
                </button>


        </div>
        </div>
        </div>




        {/* Zona 2 */}
        <div className="bg-white shadow-lg p-4 mx-4 mb-2">
            {/* Controles de Búsqueda y Exportar */}
            <div className="overflow-y-auto h-[600px] p-4">
                {/* Contenedor para los detalles de los tickets */}
                <div className="space-y-6">
                    <div class="bg-white shadow rounded-2xl overflow-hidden">
                        <div class="max-h-96 overflow-y-auto">
                            <table class="min-w-full table-auto">
                            <thead class="bg-gray-50 sticky top-0 z-10">
                                <tr>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Usuario</th>
                                    <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Password</th>
                                    <th class="px-6 py-4 text-right text-sm font-semibold text-gray-600 bg-gray-50">Rut</th>
                                    <th class="px-6 py-4 text-right text-sm font-semibold text-gray-600 bg-gray-50">Nombres</th>
                                    <th class="px-6 py-4 text-right text-sm font-semibold text-gray-600 bg-gray-50">Apellidos</th>
                                    <th class="px-6 py-4 text-right text-sm font-semibold text-gray-600 bg-gray-50">Tipo</th>
                                    <th class="px-6 py-4 text-right text-sm font-semibold text-gray-600 bg-gray-50">Cuenta</th>
                                    <th class="px-6 py-4 text-right text-sm font-semibold text-gray-600 bg-gray-50">Acciones</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-100 bg-white">
                                {dataList}
                            </tbody>
                            </table>
                        </div>

                        {/*Paginación*/} 
                        <div class="flex items-center justify-between mt-6">
                            <div class="inline-flex items-center space-x-2">
                            <Pagination currentPage={pageNumber} totalPages={totalPages} onPageChange={setPageNumber}/>            
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>        


        <Modal show={show} onHide={handleClose} size="lg" fullscreen="true">
            <Modal.Header closeButton>
                <Modal.Title>Detalle Usuario</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alert
                        ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlert}</Alert.Heading>
                                <p>
                                    {textoAlert}
                                </p>
                        </Alert>
                        :''
                        }
                    </div>
                </div>
                <div className='w-full'>
                    {dataListDetalle}       
                </div>
                
                


            </Modal.Body>
            <Modal.Footer>
                <button onClick={handleClose}>
                    Cerrar
                </button>
            </Modal.Footer>
            <Modal.Footer className={visible}>
            <div>
                <h4>Debe completar todos los campos</h4>
            </div>
            </Modal.Footer>
        </Modal>                                                                                                                                                                                           
    </div>    
    )
}
export default Grillaboticketusersreport